<h2 mat-dialog-title>Buscar por dirección</h2>
<mat-dialog-content class="mat-typography px-2">
  <mat-form-field class="w-full" appearance="fill">
    <mat-label>Dirección</mat-label>
    <input type="text"
           placeholder="Ingresá tu dirección"
           aria-label="Ingresá tu dirección"
           matInput
           [(ngModel)]="query"
           (ngModelChange)="searchPlace()"
           [formControl]="myControl"
           [matAutocomplete]="auto">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option (click)="selectPlace(place)" *ngFor="let place of places" [value]="place">
        {{place.description}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <div class="grid grid-cols-6 gap-6 mx-10 my-5" *ngIf="location && location.nomenclature && location.nomenclature?.length > 1">
    <div class="col-span-6 sm:col-span-3">
      <label for="name" class="block text-sm font-medium text-gray-700">Piso</label>
      <input type="text" name="name" id="name" [(ngModel)]="location.floor" autocomplete="given-name" class="w-full shadow appearance-none border rounded py-2 px-3 text-primary leading-tight focus:outline-none focus:shadow-outline">
    </div>

    <div class="col-span-6 sm:col-span-3">
      <label for="email_address" class="block text-sm font-medium text-gray-700">Departamento</label>
      <input type="text" name="email_address" [(ngModel)]="location.department" id="email_address" autocomplete="email" class="w-full shadow appearance-none border rounded py-2 px-3 text-primary leading-tight focus:outline-none focus:shadow-outline">
    </div>
  </div>
  <h1 *ngIf="zipCode" class="text-primary font-medium">El código postal seleccionado es: {{zipCode}}</h1>
  <div class="py-2 px-2">
    <div #map class="map"></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Guardar</button>
</mat-dialog-actions>
